import { render, staticRenderFns } from "./IndexThreeAds.vue?vue&type=template&id=60a6a3ac&scoped=true&"
import script from "./IndexThreeAds.vue?vue&type=script&lang=js&"
export * from "./IndexThreeAds.vue?vue&type=script&lang=js&"
import style0 from "./IndexThreeAds.vue?vue&type=style&index=0&id=60a6a3ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a6a3ac",
  null
  
)

export default component.exports